import { IconProps } from '../../types/components';

export const SecondaryMarketIcon = ({
  fillColor = 'currentColor',
  cy,
}: IconProps) => {
  return (
    <svg
      width="26"
      height="19"
      viewBox="0 0 28 19"
      xmlns="http://www.w3.org/2000/svg"
      data-cy={cy}
    >
      <path
        d="M13.17 2.70001L6 7.48001V18H11V10H15V18H20V7.25001L13.17 2.70001Z"
        fill={fillColor}
      />
      <path
        d="M27.0078 18H20.5205V16.6353L22.8501 14.2803C23.3198 13.7979 23.6965 13.3958 23.98 13.0742C24.2677 12.7484 24.4751 12.4521 24.6021 12.1855C24.7332 11.9189 24.7988 11.6333 24.7988 11.3286C24.7988 10.9604 24.6951 10.6854 24.4878 10.5034C24.2847 10.3172 24.0117 10.2241 23.6689 10.2241C23.3092 10.2241 22.9601 10.3066 22.6216 10.4717C22.283 10.6367 21.9297 10.8716 21.5615 11.1763L20.4951 9.91309C20.7617 9.68457 21.0431 9.46875 21.3394 9.26562C21.6398 9.0625 21.9868 8.89958 22.3804 8.77686C22.7782 8.6499 23.2542 8.58643 23.8086 8.58643C24.418 8.58643 24.9406 8.69645 25.3765 8.9165C25.8166 9.13656 26.1551 9.43701 26.3921 9.81787C26.6291 10.1945 26.7476 10.6219 26.7476 11.1001C26.7476 11.6121 26.646 12.0798 26.4429 12.5029C26.2397 12.9261 25.9435 13.3451 25.5542 13.7598C25.1691 14.1745 24.7036 14.6336 24.1577 15.1372L22.9644 16.2607V16.3496H27.0078V18Z"
        fill={fillColor}
      />
      <path
        d="M13.5 0V1.51L11.0385 2.84L8.90923 4H7.34615V4.85L4.88461 6.19V8H2.42308V10H4.88461V12H2.42308V14H4.88461V18H0V9V0H13.5ZM2.42308 6H4.88461V4H2.42308V6Z"
        fill={fillColor}
      />
    </svg>
  );
};
